import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { UserAppletTokenDto } from "../../../../../models/aggregates";
import { UserAppletContainerModel } from "../../../../../models/aggregates/applet-store/user-applet-container.model";
import { ApiResponseModel, ApiVisa } from '../shared';
import { BaseApiTemplateService } from '../shared/base-api-template-service.model';
import { Core2Config } from '../shared/core2Config';


@Injectable({
  providedIn: 'root'
})
export class UserAppletTenantService extends BaseApiTemplateService<UserAppletContainerModel> {
  protected apiUrl: string;

  constructor(http: HttpClient) {
    super();
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + 'applet-login-subject-link';
    this.httpClient = http;
  }

  getAppletToken(appletCode: string[], apiVisa: ApiVisa): Observable<ApiResponseModel<UserAppletTokenDto>> {
    const apiUrl = apiVisa.api_domain_url + Core2Config.TENANT_DOMAIN_URL_PREFIX + 'get-applet-token/login-ep';
    const body = appletCode.filter(o => o && o != '');
    if (body.length === 0) return of({
      code: 'APPLET_NOT_FOUND',
      message: '',
      data: []
    });

    return this.httpClient.post<ApiResponseModel<UserAppletTokenDto>>(
      apiUrl,
      body,
      this.getHttpHeader(apiVisa)
    );
  }
}
